/**
 * Tools Section — wraps the Goal calculator, Test, Savings Index and Growth calculator.
 */
import React from 'react';
import GoalCalculatorCard from './GoalCalculatorCard';
import TestCard from './TestCard';
import SavingsIndexCard from './SavingsIndexCard';
import GrowthCalculatorCard from './GrowthCalculatorCard';

const ToolsSection = ({
  goalData, setGoalData, selectGoalPreset, calculateGoal,
  testAnswers, setTestAnswers, testResult, handleTest,
  indiceData, setIndiceData, calculateIndice, applyIndiceToChallenge18,
  calcData, setCalcData, calculateGrowth, futureValue, chartData,
  scrollToSection
}) => (
  <section className="section section-dark" id="calculadora" data-testid="tools-section">
    <div className="section-header">
      <h2 className="section-title">Herramientas Interactivas</h2>
      <p className="section-subtitle">
        Calcula, descubre y luego decide si vas a hacer algo al respecto… o si seguimos posponiendo "hasta el lunes" 😉
      </p>
    </div>

    <GoalCalculatorCard
      goalData={goalData}
      setGoalData={setGoalData}
      selectGoalPreset={selectGoalPreset}
      calculateGoal={calculateGoal}
      scrollToSection={scrollToSection}
    />

    <div className="tools-grid">
      <TestCard
        testAnswers={testAnswers}
        setTestAnswers={setTestAnswers}
        testResult={testResult}
        handleTest={handleTest}
      />

      <SavingsIndexCard
        indiceData={indiceData}
        setIndiceData={setIndiceData}
        calculateIndice={calculateIndice}
        applyIndiceToChallenge18={applyIndiceToChallenge18}
      />

      <GrowthCalculatorCard
        calcData={calcData}
        setCalcData={setCalcData}
        calculateGrowth={calculateGrowth}
        futureValue={futureValue}
        chartData={chartData}
        scrollToSection={scrollToSection}
      />
    </div>
  </section>
);

export default ToolsSection;
